export default "__VITE_ASSET__C9DqZnu5__"